export default __webpack_public_path__ + "static/media/ICI_Intercity_investment_Dark.3643b326.png";